import API from "../API";

const refreshAuthToken = async (token) => {
  if (!token) return false;

  const { data: res } = await API.postData("auth/refresh_token", {
    refresh_token: token,
  });

  return res.data;
};

export default refreshAuthToken;
